export default __webpack_public_path__ + "static/media/shawarmapalace.4a7be8fb.webp";